import axios from 'axios'
import { signOut } from 'next-auth/react'

export const auctionApi = axios.create({
  baseURL: `${process.env.NEXT_PUBLIC_API_ROOT}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
})

auctionApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 401) {
      // Hacer dinámico la BaseURL
      // signOut({ callbackUrl: 'https://clikauto.com/subastas?openLoginModal=true' })
      signOut({ callbackUrl: 'https://clikauto.com/subastas?openLoginModal=true' })
    }
  },
)

export default auctionApi
